<template lang="pug">
  y-dialog(v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card(flat)
      v-card-title.pa-4
        div.h6.primary500--text {{ $t('order') }} {{ '#' + lead.rid }}
        v-spacer
        v-btn(color="transparent" icon small @click="closeDialog")
          eva-icon.mt-1(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
      v-card-text.px-4.py-0
        div(style="border:1px solid var(--v-basic400); border-radius: 4px;")
          .address
            v-row.pa-4(no-gutters align="center")
              v-col(cols="6")
                div.d-flex.align-center(v-if="yezzaShipping.sender_address")
                  eva-icon.mr-4(name="pin-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="18" height="18" style="margin-bottom: -5px")
                  div.p2.basic700--text(v-if="selectedShippingType === 'local-delivery'") {{ yezzaShipping.sender_address.address_1 }} {{ yezzaShipping.sender_address.address_2 ? ', ' + yezzaShipping.sender_address.address_2 : '' }}
                  div(v-else-if="selectedShippingType === 'courier'")
                    div.p2.basic700--text {{ yezzaShipping.sender_address.postcode }}
                    div.p2.basic700--text {{ yezzaShipping.sender_address.city }}
              v-col(cols="6")
                div.d-flex.align-center(v-if="yezzaShipping.receiver_address")
                  eva-icon.mr-4(name="arrow-forward-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="18" height="18" style="margin-bottom: -5px")
                  div.p2.basic700--text(v-if="selectedShippingType === 'local-delivery'") {{ yezzaShipping.receiver_address.address_1 }} {{ yezzaShipping.receiver_address.address_2 ? ', ' + yezzaShipping.receiver_address.address_2 : '' }}
                  div(v-else-if="selectedShippingType === 'courier'")
                    div.p2.basic700--text {{ yezzaShipping.receiver_address.postcode }}
                    div.p2.basic700--text {{ yezzaShipping.receiver_address.city }}
          v-divider.basic400

          .parcel-weight
            div.d-flex.align-center.pa-4
              div.mr-4
                BoxIcon.mb-n1(size="18" :style="{ 'color': $vuetify.theme.themes[$theme].primary }")
              div.p2.basic700--text {{ $t('total_weight') }}: {{ yezzaShipping.weight }} kg
              v-spacer
              a.button-Aa-small.my-auto.info500--text(@click="editWeightDialog = true") {{ $t('edit') }}
          v-divider.basic400

          .shipping-rates
            div.d-flex.align-center.pa-4(v-if="yezzaShipping.fulfilment")
              div(style="width: 72px" align="center")
                v-img(:src="yezzaShipping.fulfilment.meta_data.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
              div.pl-2
                div.p2.basic700--text {{ yezzaShipping.fulfilment.meta_data.delivery_time || yezzaShipping.fulfilment.title }}
                div.p2.basic700--text.text-capitalize {{ yezzaShipping.fulfilment.meta_data.service_type }}
              v-spacer
              div(align="right")
                a.button-Aa-small.my-auto.info500--text(@click="editShippingDialog = true") {{ $t('edit') }}
                div.p2.basic700--text {{ yezzaShipping.fee | displayPrice }}

            div.pa-4(v-else-if="yezzaShipping.lead_selection" style="background-color: var(--v-dangerT08);")
              div.d-flex.align-center
                eva-icon.mr-2(name="alert-triangle-outline" :fill="$vuetify.theme.themes[$theme].danger500" width="18" height="18" style="margin-bottom: -5px")
                div.c2.danger500--text {{ yezzaShipping.lead_selection.shipping_type === 'courier' ? $t('selected_courier_unavailable') : $t('selected_local_delivery_unavailable') }}
                v-spacer
                div(align="right")
                  a.button-Aa-small.my-auto.danger500--text(@click="editShippingDialog = true") {{ $t('edit') }}
              div.d-flex.align-center.mt-3
                div(style="width: 72px" align="center")
                  v-img(:src="yezzaShipping.lead_selection.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
                div.pl-2
                  div.p2.basic600--text {{ yezzaShipping.lead_selection.delivery_time || yezzaShipping.lead_selection.lead_selection }}
                  div.p2.basic600--text.text-capitalize {{ yezzaShipping.lead_selection.service_type }}
                v-spacer
                div(align="right")
                  div.p2.basic600--text {{ yezzaShipping.fee | displayPrice }}

            div.pa-4(v-else style="background-color: var(--v-dangerT08);")
              div.d-flex.align-center
                eva-icon.mr-2(name="alert-triangle-outline" :fill="$vuetify.theme.themes[$theme].danger500" width="18" height="18" style="margin-bottom: -5px")
                div.c2.danger500--text(v-if="!yezzaShipping.fulfilment") Selected {{ selectedShippingType === 'courier' ? 'courier' : 'delivery' }} unavailable
                div.c2.danger500--text(v-if="!yezzaShipping.weight") {{ $t('product_weight_missing') }}
                v-spacer
                div(align="right")
                  div.button-Aa-small.my-auto.danger500--text(@click="editShippingDialog = true") {{ $t('edit') }}

          v-divider.basic400

          .delivery-time
            div.d-flex.align-center.pa-4
              eva-icon.mr-4(name="calendar-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="18" height="18" style="margin-bottom: -5px")
              template(v-if="selectedShippingType === 'courier'")
                div.p2.basic700--text.text-capitalize(v-if="yezzaShipping.fulfilment") {{ yezzaShipping.fulfilment.meta_data.service_type }}
                  span.ml-1(v-if="yezzaShipping.delivery_at") | {{ yezzaShipping.delivery_at | displayDate }}
                  span.ml-1.c2.danger500--text(v-else) {{ $t('please_select_delivery_date') }}
                v-spacer
                a.button-Aa-small.my-auto.info500--text(@click="editDateDialog = true") {{ $t('edit') }}
              template(v-else)
                div.p2.basic700--text {{ $t('pick_up') }}
                  span.ml-1(v-if="yezzaShipping.delivery_at") | {{ yezzaShipping.delivery_at | convertServerDate }}
                  span.ml-1(v-else) {{ $t('asap') }}
                v-spacer
                a.button-Aa-small.my-auto.info500--text(@click="editDateTimeDialog = true") {{ $t('edit') }}

      v-card-actions.px-4.pb-4
        v-btn.px-0(text color="transparent" depressed small @click="openRemoveOrderDialog = true")
          eva-icon.mr-2(name="trash-outline" :fill="$vuetify.theme.themes[$theme].danger500" width="14" height="14" style="margin-bottom: -2px")
          div.button-Aa-small.danger500--text {{ $t('remove_this_order') }}

      .modal
        edit-weight(v-if="editWeightDialog" :open.sync="editWeightDialog" :parentYezzaShipping.sync="yezzaShipping" @updateWeight="editShippingDialog = true")
        edit-shipping(v-if="editShippingDialog" :open.sync="editShippingDialog" :selectedShippingType="selectedShippingType" :lead="lead" :parentSelectedFulfilment.sync="selectedFulfilment" :parentYezzaShipping.sync="yezzaShipping")
        edit-date-time(v-if="editDateTimeDialog" :open.sync="editDateTimeDialog" :parentYezzaShipping.sync="yezzaShipping")
        edit-date(v-if="editDateDialog" :open.sync="editDateDialog" :parentYezzaShipping.sync="yezzaShipping")
        y-dialog(v-if="openRemoveOrderDialog" v-model='openRemoveOrderDialog', max-width='320')
          v-card
            v-card-title.h6.basic800--text.px-4 {{ $t('remove_this_order') }}?
            v-card-text.p2.primary500--text.px-4 {{ $t('remove_this_order_desc') }}
            v-card-actions
              v-spacer
              v-btn(color='white', text @click='openRemoveOrderDialog = false')
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn.mr-2(color='danger500' depressed height=32 @click='removeOrder')
                .button-AA-small.basic100--text {{ $t('confirm') }}

</template>

<script>
import { mapActions } from 'vuex'
import EditWeight from '@/components/dialogs/yezzashipping/EditWeight.vue'
import EditShipping from '@/components/dialogs/yezzashipping/EditShipping.vue'
import EditDateTime from '@/components/dialogs/yezzashipping/EditDateTime.vue'
import EditDate from '@/components/dialogs/yezzashipping/EditDate.vue'

export default {
  name: 'EditIndividualOrder',
  props: ['open', 'parentYezzaShipping', 'selectedShippingType', 'lead'],
  components: { EditWeight, EditShipping, EditDateTime, EditDate },
  data: () => ({
    isLoading: false,
    editWeightDialog: false,
    editShippingDialog: false,
    editDateTimeDialog: false,
    editDateDialog: false,
    openRemoveOrderDialog: false,
    selectedFulfilment: null
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    yezzaShipping: {
      get () {
        return this.parentYezzaShipping
      },
      set (newValue) {
        this.$emit('update:parentYezzaShipping', newValue)
      }
    }
  },
  mounted () {
    this.selectedFulfilment = this.yezzaShipping.fulfilment
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    removeOrder () {
      this.$emit('remove', this.yezzaShipping)
      this.showModal = false
    },
    closeDialog () {
      this.showModal = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "selected_local_delivery_unavailable": "Selected local delivery unavailable",
    "asap": "ASAP",
    "remove_this_order": "Remove this order",
    "remove_this_order_desc": "Your selections for this order will not be saved."
  },
  "id": {
    "selected_local_delivery_unavailable": "Pengiriman lokal yang dipilih tidak tersedia",
    "asap": "secepatnya",
    "remove_this_order": "Hapus pesanan ini",
    "remove_this_order_desc": "Pilihan kamu untuk pesanan ini tidak akan disimpan."
  }
}
</i18n>